// project import
import dashboard from './dashboard';
import pages from './page';
import utilities from './utilities';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, pages, utilities]
};

export default menuItems;
